<!--
  - Copyright (c) ProviderTrust LLC.
  - All Rights Reserved.
  -
  - This software is confidential and proprietary information of
  - ProviderTrust LLC ("Confidential Information"). You shall not disclose
  - such Confidential Information and shall use it only in
  - accordance with the terms of the license agreement you entered
  - into with ProviderTrust.
  -->

<template>
  <registration-template>
    <h1 slot="header-title">Choose the options for your company account</h1>
    <h3 slot="header-description">
      Select your team options, types of searches, and enter your contact
      information.
    </h3>

    <div slot="content" class="app-plan-options-container">
      <h2 class="font-bold color-title-black">
        How many teams or departments at your organization will be using
        ExclusionCheck?
      </h2>

      <div class="app-plan-options py-4">
        <p v-if="teamTypeError" class="app-team-type-error pt-5">
          Please select a team option before continuing.
        </p>

        <team-options v-model="teamType" />
        <search-options
          class="mt-5"
          title="What types of searches do you need to conduct?"
          v-model="searchOptions"
          :disabled-options="disabledSearchOptions"
        />

        <p class="pt-4 pb-2">
          Need to perform over 500 searches?
          <a
            href="https://info.providertrust.com/exclusioncheck-inquiry"
            @click="analytics.logAnalytic('500+ Pricing')"
            target="_blank"
          >
            Contact us
          </a>
          for discounted pricing.
        </p>
      </div>

      <div class="d-flex">
        <v-spacer class="w-100" />
        <v-btn
          color="primary"
          class="flex-none"
          @click.native="validateAndContinue()"
        >
          Next
        </v-btn>
      </div>
    </div>
  </registration-template>
</template>
<script>
import { mapMutations } from "vuex"
import RegistrationTemplate from "@/components/Registration-Template"
import SearchOptions from "@/components/SearchOptions"
import TeamOptions from "@/components/TeamOptions"
import analytics from "@/service/analytics"

export default {
  name: "RegistrationPlanOptions",

  components: { RegistrationTemplate, SearchOptions, TeamOptions },

  data() {
    return {
      analytics: analytics,
      teamTypeError: false,
      disabledSearchOptions: this.$store.getters.searchOptions // assign initial values and not update afterwards
    }
  },

  computed: {
    teamType: {
      get() {
        return this.$store.getters.teamType
      },
      set(newValue) {
        this.$store.commit("updateTeamType", newValue)
      }
    },
    searchOptions: {
      get() {
        return this.$store.getters.searchOptions
      },
      set(newValue) {
        this.$store.commit("updateSearchOptions", newValue)
      }
    }
  },

  methods: {
    validateAndContinue: function() {
      if (this.teamType === "") {
        this.teamTypeError = true
        return
      }

      analytics.logAnalytic("Selects Paid Options", {
        "Single or Multi-Team":
          this.teamType === "SINGLE" ? "Single" : "Multi-Team",
        SSNDMF: this.searchOptions.includes("SSNDMF"),
        OFAC: this.searchOptions.includes("OFAC"),
        NPI: this.searchOptions.includes("NPI")
      })
      this.updateCurrentStep(2)
    },
    ...mapMutations(["updateCurrentStep"])
  }
}
</script>
<style lang="scss" scoped>
.app-plan-options-container {
  max-width: 38rem;
  margin: 0 auto;

  /deep/ h2 {
    font-size: 1.29rem;
  }
}

.app-plan-options {
  max-width: 35rem;
  margin: 0 auto;
}
</style>



// WEBPACK FOOTER //
// src/components/Registration-Plan-Options.vue